/*
 * Copyright © 2024 Tektelic Communications Inc.
 */

export default angular.module('tektelic.api.grafana', [])
    .factory('grafanaService', GrafanaService)
    .name;

/*@ngInject*/
function GrafanaService($http, $q) {

    var service = {
        createGatewayDashboard: createGatewayDashboard,
        createGatewayGroupsDashboard: createGatewayGroupsDashboard
    };

    return service;

    function createGatewayDashboard(gatewayId) {
        var deferred = $q.defer();
        $http.post(`/api/metrics/dashboard/gateway/${gatewayId}`).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    function createGatewayGroupsDashboard(gatewayGroupIds) {
        var deferred = $q.defer();
        $http.post('/api/metrics/dashboard/gatewayGroups', {gatewayGroupIds: gatewayGroupIds}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }
}


// WEBPACK FOOTER //
// ./src/app/api/grafana.service.js